import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { fetchAsyncGetPaymentLimit } from "redux/organizationSlice";

const usePaymentLimit = (moduleId) => {
    const dispatch = useDispatch();
    const { addToast } = useToasts();

    const [limits, setLimits] = useState({
      overall: {},
      module: {}
    });
    
    const fetchPaymentLimit = useCallback(() => {
      dispatch(fetchAsyncGetPaymentLimit(moduleId))
        .then((res) => {
          if (res?.payload) {
            const limitData = res.payload.results;
            setLimits({
              overall: limitData.overallRemaining,
              module: limitData[moduleId]
            });
          }
        })
        .catch((err) => {
            addToast(`${err?.message}`, { appearance: "error" });
        });
    }, [moduleId]);
  
    useEffect(() => {
      fetchPaymentLimit();
    }, [fetchPaymentLimit]);
  
    return { limits };
  };

  export default usePaymentLimit